enum LANGUAGE_CODE {
  de ='de',
  en ='en',
  fr ='fr',
  it ='it',
}

export { LANGUAGE_CODE };
